module.exports = __webpack_public_path__ + "img/feedback-e997ad6f.eb3a60ad.png";